import { Component } from '@angular/core';

@Component({
  selector: 'om-svg-speech-bubble-circled',
  template: `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="24" fill="#C5E5DD" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.1601 14.083C12.6516 14.083 11.4287 15.3059 11.4287 16.8144V30.6388C11.4287 32.1474 12.6516 33.3703 14.1601 33.3703H23.9092V37.6395C23.9092 38.1638 24.5563 38.4113 24.9062 38.0208L29.0734 33.3703H33.6573C35.1658 33.3703 36.3887 32.1474 36.3887 30.6389V16.8144C36.3887 15.3059 35.1658 14.083 33.6573 14.083H14.1601Z"
        fill="white"
      />
      <path
        d="M23.9092 33.3703H24.4092V32.8703H23.9092V33.3703ZM24.9062 38.0208L24.5338 37.6872L24.9062 38.0208ZM29.0734 33.3703V32.8703H28.85L28.701 33.0366L29.0734 33.3703ZM11.9287 16.8144C11.9287 15.582 12.9278 14.583 14.1601 14.583V13.583C12.3755 13.583 10.9287 15.0298 10.9287 16.8144H11.9287ZM11.9287 30.6388V16.8144H10.9287V30.6388H11.9287ZM14.1601 32.8703C12.9278 32.8703 11.9287 31.8712 11.9287 30.6388H10.9287C10.9287 32.4235 12.3755 33.8703 14.1601 33.8703V32.8703ZM23.9092 32.8703H14.1601V33.8703H23.9092V32.8703ZM24.4092 37.6395V33.3703H23.4092V37.6395H24.4092ZM24.5338 37.6872C24.5176 37.7053 24.5056 37.7092 24.4981 37.7108C24.4876 37.7131 24.4722 37.7128 24.4551 37.7062C24.438 37.6997 24.4263 37.6896 24.42 37.6809C24.4155 37.6747 24.4092 37.6638 24.4092 37.6395H23.4092C23.4092 38.6226 24.6225 39.0867 25.2786 38.3545L24.5338 37.6872ZM28.701 33.0366L24.5338 37.6872L25.2786 38.3545L29.4457 33.7039L28.701 33.0366ZM33.6573 32.8703H29.0734V33.8703H33.6573V32.8703ZM35.8887 30.6389C35.8887 31.8712 34.8897 32.8703 33.6573 32.8703V33.8703C35.442 33.8703 36.8887 32.4235 36.8887 30.6389H35.8887ZM35.8887 16.8144V30.6389H36.8887V16.8144H35.8887ZM33.6573 14.583C34.8897 14.583 35.8887 15.5821 35.8887 16.8144H36.8887C36.8887 15.0298 35.442 13.583 33.6573 13.583V14.583ZM14.1601 14.583H33.6573V13.583H14.1601V14.583Z"
        fill="#004D49"
      />
      <path
        d="M19.3711 23.7269L22.7747 27.1305L29.582 20.3232"
        stroke="#004D49"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  `,
  standalone: true,
})
export class SvgSpeechBubbleCircled {}
